(function () {
  const ready = (callback) => {
    if (document.readyState !== "loading") {
      callback();
    } else {
      document.addEventListener("DOMContentLoaded", callback);
    }
  };

  ready(() => {
    waitForGsap();
  });

  function waitForGsap() {
    if (!window.gsap || !window.ScrollTrigger) {
      setTimeout(waitForGsap, 50);
      return;
    }

    initAbzGsap();
  }

  function initAbzGsap() {
    if (window.__ABZ_GSAP_INITIALIZED__) return;
    window.__ABZ_GSAP_INITIALIZED__ = true;

    gsap.registerPlugin(ScrollTrigger);

    // =====================================
    // LENIS
    // =====================================

    if (window.Lenis) {
      window.lenis = new Lenis({
      duration: 1.2,
      smoothWheel: true,
      wheelMultiplier: 1
    });

    window.lenis.on("scroll", ScrollTrigger.update);

    gsap.ticker.add((time) => {
      window.lenis.raf(time * 1000);
    });

      gsap.ticker.lagSmoothing(0);
    }

    gsap.config({
      force3D: true
    });

   // =====================================
// OCHO STYLE HEADER SCROLL PROGRESS BAR
// =====================================

function initOchoProgressBar() {
  const oldProgress = document.querySelector(".ocho-scroll-progress");
  if (oldProgress) oldProgress.remove();

  const oldStyle = document.querySelector("#ocho-scroll-progress-style");
  if (oldStyle) oldStyle.remove();

  const style = document.createElement("style");
  style.id = "ocho-scroll-progress-style";

  style.textContent = `
    :root {
      --ocho-scroll-progress: 0;
      --ocho-progress-height: 5px;
      --ocho-progress-color: #b22828;
    }

    .ocho-scroll-progress {
      position: fixed !important;
      top: calc(var(--header-height, 92px) - var(--ocho-progress-height)) !important;
      left: 0 !important;
      width: 100vw !important;
      height: var(--ocho-progress-height) !important;
      z-index: 2147483647 !important;
      pointer-events: none !important;
      background: transparent !important;
      overflow: hidden !important;
      display: block;
    }

    .ocho-scroll-progress::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: var(--ocho-progress-color);
      transform: scaleX(var(--ocho-scroll-progress));
      transform-origin: left center;
      will-change: transform;
      display: block;
    }

    @media screen and (max-width: 749px) {
      .ocho-scroll-progress {
        top: calc(var(--header-height, 70px) - 3px) !important;
        height: 3px !important;
      }
    }
  `;

  document.head.appendChild(style);

  const progressWrap = document.createElement("div");
  progressWrap.className = "ocho-scroll-progress";
  progressWrap.setAttribute("aria-hidden", "true");
  document.body.prepend(progressWrap);

  function updateProgress() {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    const maxScroll =
      document.documentElement.scrollHeight - window.innerHeight;

    const progress = maxScroll > 0 ? scrollTop / maxScroll : 0;

    document.documentElement.style.setProperty(
      "--ocho-scroll-progress",
      Math.min(Math.max(progress, 0), 1)
    );
  }

  updateProgress();

  window.addEventListener("scroll", updateProgress, { passive: true });
  window.addEventListener("resize", updateProgress);

  if (window.ScrollTrigger) {
    ScrollTrigger.addEventListener("refresh", updateProgress);
    ScrollTrigger.addEventListener("update", updateProgress);
  }

  if (window.lenis) {
    window.lenis.on("scroll", updateProgress);
  }
}

initOchoProgressBar();

    // =====================================
    // MAKE PREMIUM CLASSES VISIBLE
    // =====================================

    gsap.set(".abz-reveal, .abz-blur, .abz-split", {
      opacity: 1
    });

    // =====================================
    // GENERIC REVEAL
    // =====================================

    const reveal = (selector, vars = {}) => {
      gsap.utils.toArray(selector).forEach((el) => {
        gsap.fromTo(
          el,
          {
            opacity: 0,
            ...vars
          },
          {
            opacity: 1,
            x: 0,
            y: 0,
            scale: 1,
            duration: 1.5,
            ease: "power3.out",
            clearProps: "transform",

            scrollTrigger: {
              trigger: el,
              start: "top 85%",
              once: true
            }
          }
        );
      });
    };

    reveal(".abz-slide-left", { x: -150 });
    reveal(".abz-slide-right", { x: 150 });
    reveal(".abz-fade-up", { y: 80 });
    reveal(".abz-fade-down", { y: -80 });
    reveal(".abz-zoom-in", { scale: 0.8 });

    // =====================================
    // STAGGER
    // =====================================

    gsap.utils.toArray(".abz-stagger").forEach((el) => {
      gsap.from(el.children, {
        x: 80,
        opacity: 0,
        duration: 1,
        stagger: 0.15,
        ease: "power3.out",

        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          once: true
        }
      });
    });

    // =====================================
    // PARALLAX
    // =====================================

    gsap.utils.toArray(".abz-parallax img").forEach((img) => {
      gsap.to(img, {
        yPercent: 12,
        ease: "none",

        scrollTrigger: {
          trigger: img.parentElement,
          start: "top bottom",
          end: "bottom top",
          scrub: true
        }
      });
    });

    // =====================================
    // IMAGE ZOOM
    // =====================================

    gsap.utils.toArray(".abz-zoom-image img").forEach((img) => {
      gsap.fromTo(
        img,
        {
          scale: 1
        },
        {
          scale: 1.12,
          ease: "none",

          scrollTrigger: {
            trigger: img,
            start: "top bottom",
            end: "bottom top",
            scrub: true
          }
        }
      );
    });

    // =====================================
    // REVEAL
    // =====================================

    gsap.utils.toArray(".abz-reveal").forEach((box) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: box,
          start: "top 80%",
          once: true
        }
      });

      const heading = box.querySelector(".banner__heading");
      const text = box.querySelector(".banner__text");
      const buttons = box.querySelector(".banner__buttons");

      heading &&
        tl.from(heading, {
          y: 120,
          opacity: 0,
          duration: 1.3,
          ease: "power4.out"
        });

      text &&
        tl.from(
          text,
          {
            y: 60,
            opacity: 0,
            duration: 1,
            ease: "power3.out"
          },
          "-=0.8"
        );

      buttons &&
        tl.from(
          buttons,
          {
            y: 30,
            opacity: 0,
            duration: 0.8,
            ease: "power2.out"
          },
          "-=0.6"
        );
    });

    // =====================================
    // BLUR
    // =====================================

    gsap.utils.toArray(".abz-blur").forEach((box) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: box,
          start: "top 80%",
          once: true
        }
      });

      const heading = box.querySelector(".banner__heading");
      const text = box.querySelector(".banner__text");
      const buttons = box.querySelector(".banner__buttons");

      heading &&
        tl.from(heading, {
          opacity: 0,
          y: 60,
          filter: "blur(20px)",
          duration: 1.4,
          ease: "power4.out"
        });

      text &&
        tl.from(
          text,
          {
            opacity: 0,
            y: 40,
            filter: "blur(12px)",
            duration: 1,
            ease: "power3.out"
          },
          "-=1"
        );

      buttons &&
        tl.from(
          buttons,
          {
            opacity: 0,
            y: 20,
            duration: 0.8
          },
          "-=0.6"
        );
    });

    // =====================================
    // SPLIT
    // =====================================

    gsap.utils.toArray(".abz-split").forEach((box) => {
      const heading = box.querySelector(".banner__heading");
      const text = box.querySelector(".banner__text");
      const buttons = box.querySelector(".banner__buttons");

      if (!heading) return;

      const originalText = heading.textContent.trim();

      heading.innerHTML = "";

      [...originalText].forEach((char) => {
        const span = document.createElement("span");

        span.classList.add("char");
        span.innerHTML = char === " " ? "&nbsp;" : char;

        heading.appendChild(span);
      });

      const chars = heading.querySelectorAll(".char");

      gsap.set(chars, {
        opacity: 0,
        y: 120,
        rotateX: -90,
        transformPerspective: 1000
      });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: box,
          start: "top 80%",
          once: true
        }
      });

      tl.to(chars, {
        y: 0,
        opacity: 1,
        rotateX: 0,
        stagger: 0.03,
        duration: 1.2,
        ease: "power4.out"
      });

      if (text) {
        tl.from(
          text,
          {
            y: 40,
            opacity: 0,
            duration: 1,
            ease: "power3.out"
          },
          "-=0.6"
        );
      }

      if (buttons) {
        tl.from(
          buttons,
          {
            y: 20,
            opacity: 0,
            duration: 0.8,
            ease: "power2.out"
          },
          "-=0.5"
        );
      }
    });

    // =====================================
    // REFRESH
    // =====================================

    window.addEventListener("load", () => {
      ScrollTrigger.refresh();
    });

    ScrollTrigger.refresh();
  }
})();